import * as React from "react";
import { Dropdown } from "react-bootstrap";
import { DriveUIActionTypes, Feature, DriveFeature, useAppSelector, viewerUnsupported, DriveItemType } from "src/common";
import { Icon } from "src/components";
import { DropdownProps, WatchedSwitchItem } from ".";
import { RootState } from "src/store/configureStore";

// NOTE: all_actions Pass true for outside detail view component
// NOTE: permissions Pass parent collection permissions
function FileMenuComponent(props: DropdownProps) {
  const { current_account, entry, all_actions, collection_info, current_details, handleAction } = props;
  const permissions = collection_info?.permissions;
  const root_info = useAppSelector((state: RootState) => state.drive.root_info);

  // Description: Download and view file (if file type is video, only open if it is supported)
  function handleView() {
    if (!!entry.type_label && entry.type_label === DriveItemType.Video) {
      handleAction({ actionType: DriveUIActionTypes.OpenVideoIfSupported, params: entry });
    } else {
      handleAction({ actionType: DriveUIActionTypes.NavigateToUrl, params: entry });
      handleAction({ actionType: DriveUIActionTypes.DownloadAndView, params: entry });
    }
  }

  return <>
    <Dropdown.Item aria-label="Details"
      hidden={!all_actions}
      data-tooltip-id="dd-tooltip" data-tooltip-content="File Details"
      data-tooltip-place="right"
      onClick={() => handleAction({ actionType: DriveUIActionTypes.Details, params: { entry, action: DriveUIActionTypes.Lock } })}>
      <Icon className="pv-icon-finder" />Details
    </Dropdown.Item>

    {
      !!permissions &&
      <>
        <Dropdown.Item aria-label="Copy Link"
          data-tooltip-id="dd-tooltip" data-tooltip-content="Copy Link to File"
          data-tooltip-place="right"
          onClick={() => handleAction({ actionType: DriveUIActionTypes.CopyLink, params: entry })}>
          <Icon className="ficon-link" />Copy Link
        </Dropdown.Item>
        <Dropdown.Item
          hidden={viewerUnsupported(entry)}
          aria-label="View File"
          data-tooltip-id="dd-tooltip" data-tooltip-content="View File"
          data-tooltip-place="right"
          onClick={() => handleView()}>
          <Icon className="ficon-maximize" />View {entry.type_label || "File"}
        </Dropdown.Item>
        <Dropdown.Item aria-label="Download"
          hidden={Feature.hidden(DriveFeature.Download, permissions)}
          data-tooltip-id="dd-tooltip" data-tooltip-content="Download File"
          data-tooltip-place="right"
          onClick={() => handleAction({ actionType: DriveUIActionTypes.Download, params: entry })}>
          <Icon className="ficon-download" />Download
        </Dropdown.Item>
        <Dropdown.Item aria-label="Rename"
          hidden={Feature.hidden(DriveFeature.Rename, permissions)}
          data-tooltip-id="dd-tooltip" data-tooltip-content="Rename File"
          data-tooltip-place="right"
          onClick={() => handleAction({ actionType: DriveUIActionTypes.Details, params: { entry, action: DriveUIActionTypes.Rename } })}>
          <Icon className="pv-icon-compose" />Rename
        </Dropdown.Item>
        <Dropdown.Item aria-label="Edit"
          hidden={Feature.hidden(DriveFeature.EditFile, permissions)}
          data-tooltip-id="dd-tooltip"
          data-tooltip-content="Edit File"
          data-tooltip-place="right"
          onClick={() => handleAction({ actionType: DriveUIActionTypes.EditFile, params: entry })}>
          <Icon className="icon-pencil7" />Edit File
        </Dropdown.Item>
        <Dropdown.Item aria-label="Lock File"
          hidden={Feature.hidden(DriveFeature.Lock, permissions) || entry.collection_id === root_info?.collection_id}
          data-tooltip-id="dd-tooltip" data-tooltip-content="Lock File"
          data-tooltip-place="right"
          onClick={() => handleAction({ actionType: DriveUIActionTypes.Details, params: { entry, action: DriveUIActionTypes.Lock } })}>
          <Icon className="ficon-lock" />{!!entry.is_locked ? "Unlock" : "Lock"}
        </Dropdown.Item>
        <Dropdown.Item aria-label="Delete"
          hidden={Feature.hidden(DriveFeature.Delete, permissions)}
          data-tooltip-id="dd-tooltip" data-tooltip-content="Delete File"
          data-tooltip-place="right"
          onClick={() => handleAction({ actionType: DriveUIActionTypes.Delete, params: entry })}>
          <Icon className="pv-icon-trash" />Delete
        </Dropdown.Item>
        <Dropdown.Item aria-label="Move"
          hidden={Feature.hidden(DriveFeature.Move, permissions)}
          data-tooltip-id="dd-tooltip" data-tooltip-content="Move File"
          data-tooltip-place="right"
          onClick={() => handleAction({ actionType: DriveUIActionTypes.MoveModal, params: { show: true, entry } })}>
          <Icon className="pv-icon-move" />Move
        </Dropdown.Item>
        <Dropdown.Item aria-label="Duplicate"
          hidden={Feature.hidden(DriveFeature.DuplicateFile, permissions)}
          data-tooltip-id="dd-tooltip" data-tooltip-content="Duplicate File"
          data-tooltip-place="right"
          onClick={() => handleAction({ actionType: DriveUIActionTypes.DuplicateFile, params: entry })}>
          <Icon className="ficon-copy" />Duplicate
        </Dropdown.Item>
        {
          (!!collection_info && entry.id === collection_info.id) &&
          <WatchedSwitchItem
            current_account={current_account}
            entry={entry}
            hidden={!!root_info && entry.collection_id === root_info.collection_id}
            collection_info={collection_info}
            current_details={current_details}
            handleAction={handleAction} />
        }
      </>
    }
  </>;
}

export default React.memo(FileMenuComponent);